var map = {
	"./Caissa/Caissa_bot_girl.svg": 72226,
	"./Caissa/Caissa_bot_horse.svg": 31699,
	"./Caissa/PlayAndLearnTabPatternMobile.svg": 10617,
	"./Caissa/PlayModeIcon.svg": 22011,
	"./Caissa/TournamenTab.svg": 77767,
	"./Caissa/aqua_chess_pattern.svg": 81037,
	"./Caissa/chatbot/Parental_control_rules.svg": 45442,
	"./Caissa/chatbot/chessboard_stairs_chatbot_bg.svg": 23366,
	"./ChessPieces/Black-Rook.png": 25562,
	"./ChessPieces/Black-Rook.svg": 99093,
	"./ChessPieces/White-Rook.png": 87800,
	"./ChessPieces/White-Rook.svg": 17911,
	"./ChessPieces/whiterookscale.svg": 15302,
	"./Meetings/Coach.svg": 66857,
	"./Meetings/Instructor.svg": 81340,
	"./Meetings/Mentor.svg": 49734,
	"./Meetings/Pattern.svg": 18149,
	"./Meetings/Practice.svg": 11258,
	"./Otb/card_pattern.svg": 617,
	"./Otb/corner_pattern.svg": 72532,
	"./Otb/otb_image.svg": 99683,
	"./Points/negativePoint.png": 15038,
	"./Points/positivePoint.png": 99538,
	"./RequestAccess/NoPlayer.svg": 26262,
	"./ReviewGame.png": 16105,
	"./Rules-image.png": 61762,
	"./Svgs/BeginnerDashboard/Background.svg": 86197,
	"./Svgs/BeginnerDashboard/Chessboard.svg": 41241,
	"./Svgs/BeginnerDashboard/FindSquare.svg": 35653,
	"./Svgs/BeginnerDashboard/Intersect.svg": 80848,
	"./Svgs/BeginnerDashboard/IntersectPattern.svg": 56070,
	"./Svgs/BeginnerDashboard/LearningRoadmap.svg": 15301,
	"./Svgs/BeginnerDashboard/PlayAGame.svg": 31950,
	"./Svgs/BeginnerDashboard/PracticePosition.svg": 4471,
	"./Svgs/BeginnerDashboard/pawnIcon.svg": 20316,
	"./Svgs/Bolt.svg": 74893,
	"./Svgs/Bullet.svg": 69692,
	"./Svgs/CCCurrency": 70576,
	"./Svgs/CCCurrency.tsx": 70576,
	"./Svgs/CCTicketIcon": 41862,
	"./Svgs/CCTicketIcon.tsx": 41862,
	"./Svgs/Ellipse.svg": 44966,
	"./Svgs/ExclamationIcon": 13043,
	"./Svgs/ExclamationIcon.tsx": 13043,
	"./Svgs/IncorrectMove.svg": 81610,
	"./Svgs/IsOngoing.svg": 12823,
	"./Svgs/LeagueDetail.svg": 40691,
	"./Svgs/Parental_control_rules.svg": 88997,
	"./Svgs/Play active.svg": 45500,
	"./Svgs/Play and Learn active.svg": 62231,
	"./Svgs/Play and Learn normal.svg": 82588,
	"./Svgs/Play normal.svg": 67091,
	"./Svgs/Play.svg": 75178,
	"./Svgs/Play_from_any_position.svg": 52092,
	"./Svgs/PlayandLearn.svg": 7777,
	"./Svgs/Rapid.svg": 31266,
	"./Svgs/Rectangle.svg": 21755,
	"./Svgs/Snail.svg": 24287,
	"./Svgs/Summary.svg": 12812,
	"./Svgs/Tournaments.svg": 13964,
	"./Svgs/addMember.svg": 92247,
	"./Svgs/androidqr.jpg": 22131,
	"./Svgs/appModalImage.jpg": 10860,
	"./Svgs/background_frames.svg": 89525,
	"./Svgs/bannerItems/header1.png": 38364,
	"./Svgs/bannerItems/header2.png": 43447,
	"./Svgs/bannerItems/header3.png": 53454,
	"./Svgs/bannerItems/left.png": 81801,
	"./Svgs/bannerItems/right.png": 80786,
	"./Svgs/bannerItems/topHeader.png": 71758,
	"./Svgs/bannerchakra.svg": 47952,
	"./Svgs/beginIg.svg": 27247,
	"./Svgs/blue-chessboard.jpg": 37022,
	"./Svgs/blue.svg": 9960,
	"./Svgs/bottomShadow.svg": 76197,
	"./Svgs/bottombg.svg": 31184,
	"./Svgs/brief_logo.png": 13869,
	"./Svgs/bronzeMedal.svg": 4949,
	"./Svgs/brownleft.svg": 88619,
	"./Svgs/brownright.svg": 73486,
	"./Svgs/caissaAvatar.svg": 15141,
	"./Svgs/cameraPlus.svg": 49509,
	"./Svgs/cc-logo-dark.svg": 29623,
	"./Svgs/cc-logo-light.svg": 52197,
	"./Svgs/ccIcon.svg": 82573,
	"./Svgs/cc_logo.png": 88615,
	"./Svgs/ccleague.svg": 50449,
	"./Svgs/challengehover.svg": 34199,
	"./Svgs/checksquare.svg": 52745,
	"./Svgs/chessboard.svg": 59903,
	"./Svgs/chesscom.png": 33828,
	"./Svgs/chessdotcom.svg": 75784,
	"./Svgs/chevronDoubleDown.svg": 91606,
	"./Svgs/chevronDoubleUp.svg": 6733,
	"./Svgs/circle_chess_back_half.png": 25152,
	"./Svgs/coinBackgoundForGoals.svg": 6148,
	"./Svgs/coinInRewards.svg": 94454,
	"./Svgs/coming_soon.png": 8550,
	"./Svgs/coming_soon_2.png": 38249,
	"./Svgs/congrats.svg": 22619,
	"./Svgs/connection_change.svg": 89163,
	"./Svgs/correct.svg": 99534,
	"./Svgs/crossCircle.svg": 46320,
	"./Svgs/cursorclick.svg": 52962,
	"./Svgs/custom_positions_tournaments.svg": 9369,
	"./Svgs/download.svg": 54732,
	"./Svgs/endgamewhite.svg": 77340,
	"./Svgs/euros.svg": 38598,
	"./Svgs/expert_cheat_detection.svg": 24956,
	"./Svgs/fully_private_games.svg": 60520,
	"./Svgs/gameplay_assistant.svg": 78093,
	"./Svgs/giftIcon.svg": 76797,
	"./Svgs/goldMedal.svg": 90971,
	"./Svgs/green-chessboard.jpg": 27549,
	"./Svgs/green.svg": 82749,
	"./Svgs/greycircle.svg": 17269,
	"./Svgs/hint.svg": 49047,
	"./Svgs/home_page/AI-enabled Caissa.svg": 64062,
	"./Svgs/home_page/Frame.svg": 40263,
	"./Svgs/home_page/Frame1.svg": 98388,
	"./Svgs/home_page/Frame2.svg": 69895,
	"./Svgs/home_page/Frame3.svg": 30358,
	"./Svgs/home_page/PRO.svg": 62185,
	"./Svgs/home_page/Union.svg": 59669,
	"./Svgs/home_page/arrow_down.svg": 45414,
	"./Svgs/home_page/arrow_up.svg": 93021,
	"./Svgs/home_page/assessment.svg": 39774,
	"./Svgs/home_page/badge.svg": 68089,
	"./Svgs/home_page/beginners_curve.svg": 9717,
	"./Svgs/home_page/books_videos.svg": 19849,
	"./Svgs/home_page/bottomLeftSquare.svg": 34755,
	"./Svgs/home_page/bottomRightSquare.svg": 36912,
	"./Svgs/home_page/caissa.svg": 77496,
	"./Svgs/home_page/calculation_trainer.svg": 66645,
	"./Svgs/home_page/chat.svg": 32562,
	"./Svgs/home_page/chess_events.svg": 97276,
	"./Svgs/home_page/chessboard_left_part_large.svg": 35632,
	"./Svgs/home_page/chessboard_part_left.svg": 46868,
	"./Svgs/home_page/chessboard_part_right.svg": 23003,
	"./Svgs/home_page/chessboard_right_part_large.svg": 74461,
	"./Svgs/home_page/cropped_dashboard.svg": 35184,
	"./Svgs/home_page/double_arrow_up.svg": 81771,
	"./Svgs/home_page/four_squares.svg": 50281,
	"./Svgs/home_page/game_analytics.svg": 51663,
	"./Svgs/home_page/game_play.svg": 42255,
	"./Svgs/home_page/intermediate.svg": 6455,
	"./Svgs/home_page/intuition_trainer.svg": 17837,
	"./Svgs/home_page/learning.svg": 2438,
	"./Svgs/home_page/logo.svg": 20101,
	"./Svgs/home_page/organisation_trophy.svg": 92859,
	"./Svgs/home_page/parental_control.svg": 55993,
	"./Svgs/home_page/play.svg": 20318,
	"./Svgs/home_page/player.svg": 66639,
	"./Svgs/home_page/positions_trainer.svg": 90854,
	"./Svgs/home_page/review.svg": 42132,
	"./Svgs/home_page/rules.svg": 99237,
	"./Svgs/home_page/signup_assess.svg": 92653,
	"./Svgs/home_page/signup_elevate.svg": 14539,
	"./Svgs/home_page/square.svg": 55981,
	"./Svgs/home_page/square_background.svg": 29828,
	"./Svgs/home_page/sync_obt.svg": 6781,
	"./Svgs/home_page/tournament.svg": 6481,
	"./Svgs/home_page/two_squares.svg": 92539,
	"./Svgs/iosqr.jpg": 58733,
	"./Svgs/knights_elephant.png": 23749,
	"./Svgs/largest_learning_community.svg": 35351,
	"./Svgs/leagueBackground.svg": 82859,
	"./Svgs/learning/arrow.svg": 66288,
	"./Svgs/learning/assessment.svg": 1107,
	"./Svgs/learning/blunder-icon.svg": 97995,
	"./Svgs/learning/gamified-experience.svg": 80800,
	"./Svgs/learning/inaccuracy-icon.svg": 69643,
	"./Svgs/learning/master-games.svg": 317,
	"./Svgs/learning/mistakes-icon.svg": 45344,
	"./Svgs/learning/personalized-content.svg": 84839,
	"./Svgs/learning/slash.svg": 5500,
	"./Svgs/left.svg": 54271,
	"./Svgs/leftbackground.svg": 65879,
	"./Svgs/levelUnitEmpty.svg": 28391,
	"./Svgs/levelUnitEmptyBrown.svg": 70933,
	"./Svgs/levelUnitFilled.svg": 11020,
	"./Svgs/levelUnitFilledBrown.svg": 64648,
	"./Svgs/lichess.png": 74392,
	"./Svgs/lichess.svg": 4503,
	"./Svgs/logo.svg": 89721,
	"./Svgs/logoicon.svg": 59046,
	"./Svgs/mainappbanner.jpg": 56309,
	"./Svgs/message.svg": 64545,
	"./Svgs/middle.svg": 31547,
	"./Svgs/mobile_bg.svg": 85676,
	"./Svgs/mobile_corner_prize.svg": 663,
	"./Svgs/new_book_icon.svg": 57618,
	"./Svgs/no_issue_selected.svg": 9915,
	"./Svgs/pattern.svg": 43858,
	"./Svgs/pawnpair.svg": 62486,
	"./Svgs/pawns.svg": 12809,
	"./Svgs/peopleGroup.svg": 25354,
	"./Svgs/person_playing_chess.svg": 80953,
	"./Svgs/pink.svg": 84424,
	"./Svgs/playerSelected.svg": 61880,
	"./Svgs/playstore.svg": 83277,
	"./Svgs/points.svg": 54921,
	"./Svgs/pointsCoinIcon.svg": 1961,
	"./Svgs/prize.svg": 50740,
	"./Svgs/prizeapp.svg": 11669,
	"./Svgs/prizereminder.svg": 37454,
	"./Svgs/proIg.svg": 85133,
	"./Svgs/purple.svg": 48290,
	"./Svgs/puzzle_attempts.svg": 94781,
	"./Svgs/puzzle_timer.svg": 53286,
	"./Svgs/quote.png": 25679,
	"./Svgs/rectangles.svg": 63954,
	"./Svgs/reflects_your_rating.svg": 48088,
	"./Svgs/right.svg": 8218,
	"./Svgs/select_avatar.svg": 64232,
	"./Svgs/silhouette-male-icon.svg": 50822,
	"./Svgs/silverMedal.svg": 47972,
	"./Svgs/singular_ecosystem.svg": 28138,
	"./Svgs/speedometer.svg": 36267,
	"./Svgs/squares.svg": 18480,
	"./Svgs/thumsdown.svg": 66593,
	"./Svgs/thumsdownActive.svg": 12743,
	"./Svgs/thumsup.svg": 98110,
	"./Svgs/thumsupActive.svg": 95748,
	"./Svgs/toprightbg.svg": 86716,
	"./Svgs/tournament_banner/Union.svg": 14518,
	"./Svgs/tournament_banner/background_pattern.svg": 29246,
	"./Svgs/tournament_banner/background_pattern_mobile.svg": 61715,
	"./Svgs/tournament_banner/bannerMain.svg": 90704,
	"./Svgs/tournament_banner/banner_main.svg": 33661,
	"./Svgs/tournament_banner/bg_pattern.svg": 78167,
	"./Svgs/tournament_banner/black_bg_pattern.svg": 22371,
	"./Svgs/tournament_banner/calendar.svg": 54739,
	"./Svgs/tournament_banner/check_icon.svg": 28865,
	"./Svgs/tournament_banner/corner_prize.svg": 80367,
	"./Svgs/tournament_banner/corner_prize_mobile.svg": 54512,
	"./Svgs/tournament_banner/currency-circle.svg": 27861,
	"./Svgs/tournament_banner/detail_pattern.svg": 14557,
	"./Svgs/tournament_banner/gukesh.svg": 95820,
	"./Svgs/tournament_banner/hat.svg": 64388,
	"./Svgs/tournament_banner/image_1.svg": 13396,
	"./Svgs/tournament_banner/image_2.svg": 84903,
	"./Svgs/tournament_banner/image_3.svg": 97782,
	"./Svgs/tournament_banner/onboarding_tournament.svg": 2644,
	"./Svgs/tournament_banner/puzzle.svg": 55177,
	"./Svgs/tournament_banner/yellowBg.svg": 29424,
	"./Svgs/tournament_friends.svg": 98867,
	"./Svgs/trend-up-01.svg": 60187,
	"./Svgs/union.svg": 67793,
	"./Svgs/userIcon.svg": 45666,
	"./Svgs/wrong.svg": 33291,
	"./Svgs/yellow.svg": 84356,
	"./Svgs/yellowleft.svg": 89951,
	"./Svgs/yellowright.svg": 96698,
	"./Svgs/zero_assessments_state.svg": 18884,
	"./Tournaments/no_pairing.svg": 62647,
	"./Tournaments/no_standing.svg": 28937,
	"./Tournaments/no_tournament_found.svg": 34381,
	"./Workbook/WorkbookEmptyPage.svg": 21619,
	"./bishop.png": 19104,
	"./cursor-click.svg": 75057,
	"./glyphs/thumbsdown.svg": 33951,
	"./glyphs/thumbsup.svg": 31216,
	"./glyphs/tick.svg": 36643,
	"./hide.svg": 17436,
	"./icons/Rematch.png": 99954,
	"./icons/Rematch@2x.png": 71426,
	"./icons/Rematch@3x.png": 79309,
	"./icons/close.png": 48512,
	"./icons/tick.png": 52805,
	"./icons/tick@2x.png": 83727,
	"./icons/tick@3x.png": 24324,
	"./lock.png": 73286,
	"./pawn.png": 70505,
	"./png/PRO.png": 10058,
	"./png/abort.png": 22541,
	"./png/back_arrow.png": 27772,
	"./png/badge.png": 6826,
	"./png/beginners_curve.png": 26950,
	"./png/black_box.png": 86724,
	"./png/black_color.png": 30698,
	"./png/black_rook.png": 94912,
	"./png/book-closed.png": 12979,
	"./png/book.png": 44316,
	"./png/book_dummy.png": 21249,
	"./png/bottom_left_square.png": 6524,
	"./png/bottom_right_square.png": 60599,
	"./png/casual_player.png": 35362,
	"./png/challenge.png": 50872,
	"./png/challenge@2x.png": 63008,
	"./png/challenge@3x.png": 37259,
	"./png/chapter.png": 96772,
	"./png/chart.png": 54163,
	"./png/chat.png": 70721,
	"./png/checkmark.png": 6088,
	"./png/chess_events.png": 99183,
	"./png/chess_footer_background.png": 23858,
	"./png/chessboard_left_part_large.png": 69723,
	"./png/chessboard_part_left.png": 33631,
	"./png/chessboard_part_placeholder.png": 46193,
	"./png/chessboard_part_right.png": 83920,
	"./png/chessboard_right_part_large.png": 53990,
	"./png/circle_chess_logo.png": 46066,
	"./png/circle_chess_logo_black.png": 55702,
	"./png/circlechess_screenshot.png": 17108,
	"./png/custom_rules_icon.png": 68988,
	"./png/custom_rules_modal.png": 40148,
	"./png/defeat_result.png": 48476,
	"./png/delete.png": 31882,
	"./png/diagonal_chess_part.png": 97687,
	"./png/double_arrow_up.png": 35952,
	"./png/draw.png": 72549,
	"./png/draw_result.png": 59249,
	"./png/dropdown.png": 16772,
	"./png/elevate.png": 48317,
	"./png/empty_book.png": 35646,
	"./png/empty_result.png": 3586,
	"./png/endgame.png": 7902,
	"./png/engine.png": 8301,
	"./png/eye.png": 56116,
	"./png/file.png": 57441,
	"./png/gamesummary.png": 21337,
	"./png/go_back.png": 47207,
	"./png/home.png": 50638,
	"./png/intermediate.png": 66628,
	"./png/late_guess.png": 92209,
	"./png/learning.png": 34050,
	"./png/level_unit_empty.png": 82422,
	"./png/level_unit_filled.png": 17577,
	"./png/master.png": 72433,
	"./png/middlegame.png": 58742,
	"./png/mobileOne.png": 39301,
	"./png/newGame.png": 21015,
	"./png/opening.png": 9691,
	"./png/opening2.png": 66721,
	"./png/organisation_trophy.png": 4920,
	"./png/player.png": 18140,
	"./png/random_color.png": 88814,
	"./png/record_button.png": 70097,
	"./png/refresh.png": 93306,
	"./png/resign.png": 80283,
	"./png/review_game.png": 71266,
	"./png/search.png": 13775,
	"./png/settings.png": 93196,
	"./png/settings_close.png": 86301,
	"./png/shopping-bag.png": 84466,
	"./png/signup_assess.png": 62638,
	"./png/signup_elevate.png": 78584,
	"./png/signup_play.png": 74550,
	"./png/square_background.png": 34359,
	"./png/stockfish_settings.png": 94763,
	"./png/stop_record.png": 4479,
	"./png/trash.png": 66029,
	"./png/upload.png": 30936,
	"./png/voice_process.png": 50559,
	"./png/whatsapp_say_hi.png": 84803,
	"./png/whatsapp_share.png": 52933,
	"./png/white_box.png": 39122,
	"./png/white_color.png": 50832,
	"./png/white_rook.png": 42650,
	"./png/win_result.png": 43029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71187;